import { rem } from "@certn/cascadia";
import { css } from "@emotion/css";

export function usePhotoVerificationStyles() {
  return {
    container: css({
      display: "grid",
      position: "relative",
      width: "100%",
      overflow: "hidden",
    }),
    ellipse: css({
      width: "50%",
      height: "65%",
      background: "transparent",
      borderRadius: "50%",
      position: "absolute",
      top: 40,
      boxShadow: "#0008 0px 0px 0px 2000px, 0px 0px 50px inset",
      justifySelf: "center",
    }),
    footer: css({
      position: "absolute",
      width: "100%",
      display: "flex",
      gap: rem("space-2"),
      justifyContent: "center",
      bottom: 0,
      padding: rem("space-3"),
      boxSizing: "border-box",
    }),
    image: css({ width: "100%" }),
    errorContainer: css({
      position: "absolute",
      justifySelf: "center",
      alignSelf: "center",
      textAlign: "center",
    }),
  };
}
